import React, { useEffect, useState } from "react";
import SlideDown from "react-slidedown";
import "react-slidedown/lib/slidedown.css";
import { ListItem } from "../ListItem";
import "./styles.scss";
import { GuestProps, GuestCard } from "../GuestCard/guest-card";

interface LineupTabProps {
  isExpanded: boolean;
  events: {
    time: string;
    title: string;
    type: number;
    guests: number[];
    id: number;
  }[];
  label: string;
  people: GuestProps[];
}

export const getEventBoxColor = (type: number): string => {
  switch (type) {
    case 0:
      return "#8B9292";
    case 1:
      return "#f8ed6e";
    case 2:
      return "#09C6C6";
    case 3:
      return "#d658bb";
    case 4:
      return "#40cc7f";
    default:
      return "";
  }
};

export const LineupTab = (props: LineupTabProps): JSX.Element => {
  const { events, isExpanded, label, people } = props;
  const getGuestById = (id: number) =>
    people.find((person) => person.id === id);

  const [expandedEvents, setExpandedEvents] = useState<number[]>([]);
  useEffect(() => {
    if (isExpanded) {
      setExpandedEvents([]);
    }
  }, [isExpanded]);
  const toggleExpandedEvent = (id: number): void => {
    if (expandedEvents.includes(id)) {
      setExpandedEvents(expandedEvents.filter((event) => event !== id));
    } else {
      setExpandedEvents([...expandedEvents, id]);
    }
  };

  return (
    <div className="lt">
      <div className="lt-header">
        <h5>{label}</h5>
      </div>
      <div className="lineup-timeline">
        {events.map((event) => (
          <ListItem
            key={event.title}
            isShorter={event.id === 34}
          >
            <div className="li-box-wrapper">
              <button
                type="button"
                onClick={() => toggleExpandedEvent(event.id)}
              >
                <div
                  className="li-box"
                  style={{ borderColor: getEventBoxColor(event.type) }}
                >
                  <h6>{event.title}</h6>
                </div>
              </button>
              <SlideDown className="my-dropdown-slidedown">
                {(expandedEvents.find((eventId) => eventId === event.id) ||
                  isExpanded) && (
                  <div className="li-meta">
                    <div className="li-guests">
                      {event.guests.map((guest) => {
                        const guestInfo = getGuestById(guest);
                        return (
                          <GuestCard guest={guestInfo} key={guestInfo?.id} />
                        );
                      })}
                    </div>
                  </div>
                )}
              </SlideDown>
            </div>
          </ListItem>
        ))}
      </div>
    </div>
  );
};
